import { map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppConfig } from '../helpers/app.config';
import { Question } from '../models/question.model';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(
    private httpClient: HttpClient,
    private utilsService: UtilsService
  ) { }

  getNextQuestion(token, instructions?): Observable<Question> {
    const params: HttpParams = this.utilsService.createHttpParams({ instructions });

    return this.httpClient.get<Question>(AppConfig.settings.API + '/question/' + token,
      { params }
    );
  }

  putAnswer(token, answer): Observable<any> {
    return this.httpClient.put<Question>(AppConfig.settings.API + '/question/' + token, { answer });
  }
}
